import { render, staticRenderFns } from "./RegionsComponent.vue?vue&type=template&id=4607850a&"
import script from "./RegionsComponent.vue?vue&type=script&lang=js&"
export * from "./RegionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports